export const fontSize = {
    h1: {
        large: 48,
        medium: 36,
        small: 32
    },
    h2:
    {
        large: 32,
        medium: 24,
        small: 20

    },
    h3: {
        large: 20,
        medium: 16,
        small: 14
    },
    h4: {
        large: 16,
        medium: 14,
        small: 12
    },
    body: {
        large: 16,
        medium: 14,
        small: 12
    },
    caption: {
        large: 12,
        medium: 11,
        small: 10
    }

}